import Swal from "sweetalert2";
import { RemoteConstants } from "../../../data/remote/RemoteConstants";
import { UIActions } from "../../../presentation/redux/actions/UIActions";
import { handleLogout } from "../../../presentation/utils/handleLogout";
import { errorManager } from "../../../presentation/utils/errorManager";

export const sendEmailValidation = async (email, token, dispatch) => {
  try {
    const params = new URLSearchParams({
      token: token,
      email: email.trim()
    });
    const peticion = await fetch(`${RemoteConstants.BASE_URL}pos/send/email/validation?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(resp => {
        return resp.json();
      })
      .then(data => {
        if (data.code === 'OK') {
          Swal.fire({
            title: "Correo de verificación enviado",
            text: data.userMessage,
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
            allowOutsideClick: false
          }).then((result) => {
            if (result.isConfirmed) {
              handleLogout();
            }
          })
        } else {
          errorManager(data.userMessage)
        }
      });
  } catch (error) {
    errorManager(error)
  }
  dispatch(UIActions.uiLoadInactive());
}